export default "__VITE_ASSET__a46ada8a__"